import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';

import actions from 'state/mrDistribution/repeated-from/actionCreators';
import initialState from 'state/mrDistribution/repeated-from/initial.state';
import { types as orderActionTypes } from 'state/order';

const repeatedFrom = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [orderActionTypes.cleanRepeatAndEditing$]: () => initialState,
    [actions.setRepeatedFrom]: (state, { payload: { orderId } }) => orderId,
  },
  initialState
);

export default repeatedFrom;
